import { c as _c } from "react/compiler-runtime";
import { useState, type FC, type PropsWithChildren } from 'react';
import classnames from 'classnames';
import { TextLink, FullModal } from '@sbt-web/ui';
import css from './style/brandvideo.module.scss';
export interface DialogProps {
  videoId?: string;
  url: string;
  name: string;
  classes?: string[];
}
export const BrandVideo: FC<PropsWithChildren<DialogProps>> = t0 => {
  const $ = _c(21);
  const {
    videoId,
    url,
    name,
    classes,
    children
  } = t0;
  const [showDialog, setShowDialog] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowDialog(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== classes) {
    t2 = classnames(classes, css["quality-seal-button"]);
    $[1] = classes;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <button type="button" onClick={t1} className={t2}>{children}</button>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setShowDialog(false);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&showinfo=0&rel=0&modestbranding=1`;
  const t6 = `Un video su YouTube che descrive ${name}`;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <iframe src={t5} className={css["quality-seal-video-frame"]} allowFullScreen={true} seamless={true} width="740" height="360" title={t6} />;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [css["quality-seal-dialog-link"]];
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `Maggiori Informazioni su ${name}`;
  let t10;
  if ($[11] !== t9 || $[12] !== url) {
    t10 = <TextLink href={url} target="_blank" classes={t8} rel="noopener nofollow external" size="md">{t9}</TextLink>;
    $[11] = t9;
    $[12] = url;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== showDialog || $[15] !== t10 || $[16] !== t7) {
    t11 = <FullModal open={showDialog} title="Informazioni" onClose={t4} inset={true}>{t7}{t10}</FullModal>;
    $[14] = showDialog;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t3) {
    t12 = <>{t3}{t11}</>;
    $[18] = t11;
    $[19] = t3;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};
BrandVideo.displayName = 'BrandVideo';
export default BrandVideo;